import React from 'react';
import { ReactComponent as Chevron } from '../../../../../../../assets/icons/chevron.svg';
import { ReactComponent as DurationIcon } from '../../../../../../../assets/icons/redesign_duration_icon.svg';
import styles from './DurationFilter.module.scss';
import { useResultListContext } from 'common/contexts/ResultListContext';
import {addGTMEvent} from "../../../../../../../helpers/analytics";

export interface Props {
  handleDurationSelection: (index: number) => void;
}

const DurationFilter = ({ handleDurationSelection }: Props) => {
  const [isFilterVisible, setIsFilterVisible] = React.useState(true);

  const { durationOptions } = useResultListContext();

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevIsFilterVisible) => !prevIsFilterVisible);
    if(isFilterVisible){
      addGTMEvent('duration_filter_menu_close', {  'listings_view_type' : viewParam });
    } else {
      addGTMEvent('duration_filter_menu_open', {  'listings_view_type' : viewParam });
    }
  };
  const viewParam = new URLSearchParams(window.location.search).get('view');

  return (
    <button className={styles.container} onClick={toggleFilterVisibility} type="button">
      <div className={styles.heading}>
        <div className={styles.toggle}>
          <DurationIcon />
          Duration
        </div>
        <Chevron style={{ transform: !isFilterVisible ? 'rotate(270deg)' : 'none' }} />
      </div>
      {isFilterVisible && (
        <div
          className={styles.container__filters}
          data-testid="filters-container"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {durationOptions.map((option:any, index:any) => (
            <label key={option.title} className={styles.container__filters__option}>
              <div>
                <input
                  checked={durationOptions[index].isActive || false}
                  id={option.title}
                  name={option.title}
                  onChange={() => {
                    handleDurationSelection(index);
                    addGTMEvent('duration_filter_menu_apply', {  'listings_view_type' : viewParam, duration_selection: option.title });
                  }}
                  type="checkbox"
                />
                <span className={styles.container__filters__option__checkbox} />
              </div>
              <span className={styles.container__filters__option__checkbox_text}>
                {option.title}
              </span>
            </label>
          ))}
        </div>
      )}
    </button>
  );
};

export default DurationFilter;
